export const JSON_SCHEMA_TYPES = {
	STRING: 'string',
	NUMBER: 'number',
	INTEGER: 'integer',
	BOOLEAN: 'boolean',
	OBJECT: 'object',
	ARRAY: 'array',
	NULL: 'null',
} as const;

export const JSON_SCHEMA_FORMATS = {
	UUID: 'uuid',
	DATE_TIME: 'date-time',
	DATE: 'date',
	TIME: 'time',
	EMAIL: 'email',
	URI: 'uri',
} as const;

export type JsonSchemaEnumReference = {
	id: string;
	name?: string;
	contextId?: string;
	contextName?: string;
};

export type JsonSchemaModel = {
	$id?: string;
	title?: string;
	description?: string;
	type?: JsonSchemaType | JsonSchemaType[];
	anyOf?: JsonSchemaModel[];
	oneOf?: JsonSchemaModel[];
	allOf?: JsonSchemaModel[];
	const?: unknown;
	'x-allowsNull'?: boolean;
	format?: string;
	properties?: Record<string, JsonSchemaModel>;
	additionalProperties?: JsonSchemaModel | boolean;
	required?: string[];
	items?: JsonSchemaModel | JsonSchemaModel[];
	enum?: (string | number)[];
	'x-enumRef'?: JsonSchemaEnumReference;
};

export type JsonSchemaType = 'string' | 'number' | 'integer' | 'boolean' | 'object' | 'array' | 'null';
